import { createSelector } from "reselect";
import { InstantCode } from "../utils/lynkco-constants";

export const isMemberSelector = state => !!state.user?.email;
export const isGuestSelector = state => !!state.guest?.email;
export const emailSelector = state => state.user?.email || state.guest?.email;
export const deliverySelector = state => state?.delivery;
export const billingInfoSelector = state => state?.billingInfo;
export const shippingInfoSelector = state => state?.shippingInfo;
export const diffAddrSelector = state => state?.diffAddr;
export const contactInfoSelector = state => state?.contactInfo;
export const cartItemsSelector = state => state?.cartItems;
export const isInstantSelector = createSelector(deliverySelector, delivery => {
  return delivery?.code === InstantCode;
});
// export const cartQtyListSelector = createSelector(
//   cartItemsSelector,
//   cartItems => {
//     return cartItems.reduce((prev, current) => {
//       const item = prev.find(e => e.skuId === current.skuId);
//       if (item) {
//         item.qty += 1;
//       } else {
//         prev.push({
//           skuId: current.skuId,
//           qty: 1
//         });
//       }
//       return prev;
//     }, []);
//   }
// );
// export const cartSpuIdsSelecror = createSelector(
//   cartItemsSelector,
//   cartItems => {
//     return cartItems.reduce((prev, current) => {
//       if (!prev.includes(current.spuId)) {
//         prev.push(current.spuId);
//       }
//       return prev;
//     }, []);
//   }
// );
export const orderNoSelector = state => state?.orderNo;
export const cartInfoSelector = state => state?.cartInfo;
export const disabledSkuIdsSelector = state => state?.disabledSkuIds;
export const pickupStoreSelector = state => state?.pickupStore;
